module.exports = __webpack_public_path__ + "img/red-rectangle-table-8.d658a60e.png";